export default {"src":"/_next/static/media/SRC.0570c973.svg","height":18,"width":18};